/**
 * Components: Property.
 *
 * Display a property with the add buttons and the list of property instances (values).
 *
 * - Form
 *    - Property 1
 *      - Instance 1
 *      - Instance 2
 *      - Instance ...
 *    - Property 2
 *    - Property ...
 *
 * @since 1.0.0
 */

/*
 * External dependencies.
 */
import React from "react";
import { Map, Set } from "immutable";

/*
 * Internal dependencies.
 */
import Add from "../../Add";
import Button from "./Button";
import uuid from "./uuid";
import PropertyInstanceFactory from "./PropertyInstanceFactory";

/**
 * Display a Schema.org property element.
 *
 * @since 1.0.0
 */
class Property extends React.Component {
  constructor(props) {
    super(props);

    // Bind functions.
    this.handleAdd = this.handleAdd.bind(this);
    this.handleRemove = this.handleRemove.bind(this);

    // The Property Instance decorator.
    this.propertyInstanceDecorator =
      props.propertyInstanceDecorator || (Component => Component);

    this.PropertyInstance = this.propertyInstanceDecorator(
      PropertyInstanceFactory
    );

    // Set the initial state to an empty ordered map of properties.
    this.state = {
      values: Map(
        (props.values || []).map(value => [uuid(), value])
      ).toOrderedMap()
    };
  }

  handleAdd(property, range) {
    this.setState(prevState => ({
      values: prevState.values.set(uuid(), { type: range.name, value: "" })
    }));
  }

  handleRemove(key) {
    this.setState(prevState => ({
      values: prevState.values.delete(key)
    }));
  }

  render() {
    const { property, ...otherProps } = this.props;
    return (
      <div>
        <strong>{property.name}</strong>
        <Add property={property} onAdd={this.handleAdd} />
        {this.state.values
          // The `key` is the `uuid`.
          // We only pass `property` to the `Instance` component, since it shouldn't need anything
          // else and other properties may conflict.
          .map((value, key) => (
            <div key={key}>
              <Button onClick={() => this.handleRemove(key)} />
              <this.PropertyInstance
                property={property}
                propertyValue={value}
              />
            </div>
          ))
          .valueSeq()}
        {/*<div>{property.description}</div>*/}
        <hr style={{ color: "#007aff", width: "100%", height: "1px" }} />
      </div>
    );
  }
}

export default Property;
